import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
const FORM_FIELD_TEMPLATE_TYPE_FIELD_NAME = "_templateType";
/**
 * Template Type indication within form. Hidden item.
 *
 * @param type Service or Content-Blocker
 * @returns Form.Item
 */ function FormFieldTemplateType(props) {
    const { type } = props;
    return /*#__PURE__*/ _jsx(Form.Item, {
        name: FORM_FIELD_TEMPLATE_TYPE_FIELD_NAME,
        initialValue: type,
        hidden: true,
        children: /*#__PURE__*/ _jsx(Input, {
            type: "hidden"
        })
    });
}
export { FormFieldTemplateType, FORM_FIELD_TEMPLATE_TYPE_FIELD_NAME };
